function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */

import { css } from '@emotion/react';
import { euiFontSize, logicalCSS } from '../../global_styling';
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1bwn7gf-isTruncated",
  styles: "flex-wrap:nowrap;white-space:nowrap;label:isTruncated;"
} : {
  name: "1bwn7gf-isTruncated",
  styles: "flex-wrap:nowrap;white-space:nowrap;label:isTruncated;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export var euiBreadcrumbsListStyles = function euiBreadcrumbsListStyles(euiThemeContext) {
  // Styles cast to the <ol> element
  var euiTheme = euiThemeContext.euiTheme;
  return {
    euiBreadcrumbs__list: /*#__PURE__*/css(euiFontSize(euiThemeContext, 's'), " align-items:center;display:flex;flex-wrap:wrap;line-height:", euiTheme.size.l, ";row-gap:", euiTheme.size.xs, ";", logicalCSS(
    // Ensure it shrinks if the window is narrow
    'min-width', 0), ";;label:euiBreadcrumbs__list;"),
    isTruncated: _ref
  };
};